import { render } from "./StepsComponent.vue?vue&type=template&id=51a2ea4b&scoped=true"
import script from "./StepsComponent.vue?vue&type=script&lang=js"
export * from "./StepsComponent.vue?vue&type=script&lang=js"

import "./StepsComponent.vue?vue&type=style&index=0&id=51a2ea4b&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a2ea4b"]])

export default __exports__